import React, { useState } from 'react';

const ClientTriage = () => {
    const [selection, setSelection] = useState('');

    const handleNewClient = () => {
        setSelection('new');
        console.log('New Client selected');
        // Add your action for new customer here
    };

    const handleExistingClient = () => {
        setSelection('existing');
        console.log('Existing Client selected');
        // Add your action
    };

    return (
        <>
            <section className="card client-triage">
                {selection === 'new' ? (
                    <div className="client-triage-new card-body">
                        <div className="alert alert-warning"><strong>We are not accepting new clients at this time</strong></div>
                        <p className="card-text mb-1">If you would like to join the waitlist, please call our office at: <a href="tel:4342936896">(434) 293-6896</a></p>
                    </div>
                ) : selection === 'existing' ? (
                    <div class="client-triage-existing card-body d-flex gap-2 justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row">
                        <div>
                            <h2 class="card-title mb-1">Schedule An Appointment</h2>
                            <p class="card-text mb-1">For current clients, call our front desk or book a time that works for you.</p>
                        </div>
                        <a href="https://calendly.com/billyhaycpa/client-tax-meeting" class="btn btn-outline-primary">BOOK A TIME</a>
                    </div>
                ) : (
                    <div className="card-body">
                        <h2 className="card-title mb-3">Get In Touch</h2>
                        <div className="d-flex gap-2 flex-column flex-sm-row">
                            <button className="btn btn-outline-primary w-100" onClick={handleExistingClient}>
                                Current Clients
                            </button>
                            <button className="btn btn-outline-primary w-100" onClick={handleNewClient}>
                                New Clients
                            </button>
                        </div>
                    </div>
                )}
            </section>
            {selection !== '' && (
                <button className="btn btn-link m-0" onClick={() => setSelection('')}>
                    {selection === 'new' ? 'Not a new client?' : 'Not a current client?'}
                </button>
            )}
        </>
    );
};

export default ClientTriage;